import styled from "styled-components";
import { motion } from "framer-motion";

export const MedicoSolicitanteContainer = styled(motion.div)`
  width: 100%;
  padding: 0 14px;
  .ValidaTurno-separador {
    height: 2px;
    margin: 20px;
    background-color: var(--color-grey95);
  }
`;
export const MedicoSolicitanteTitulo = styled.div`
  display: flex;
  justify-content: center;
`;

export const MedicoSolicitanteBody = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  .ValidaTurno-bodytxt {
    text-align: center;
  }
  .ValidaTurno-input {
    width: 190px;
  }
`;
export const MedicoSolicitanteContainerBotones = styled.div`
  display: flex;
  justify-content: center;
  /* margin-top: 30px; */
`;

export const ResumenBotones = styled.div`
  /* position: absolute; */
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: max-content;
  height: max-content;
  padding-bottom: 70px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  button {
    width: 215px;
    height: 45px;
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    color: var(--color-white);
    background-color: var(--color-primary);
    border-radius: 8px;
  }
  .danger {
    background-color: var(--color-danger);
  }
  @media (max-height: 700px) {
    padding-bottom: 20px;
  }
  @media (max-height: 620px) {
    display: none;
  }
`;
